<script setup>
import Checkbox from '@/Components/Checkbox.vue';
import GuestLayout from '@/Layouts/GuestLayout.vue';
import InputError from '@/Components/InputError.vue';
import InputLabel from '@/Components/InputLabel.vue';
import PrimaryButton from '@/Components/PrimaryButton.vue';
import TextInput from '@/Components/TextInput.vue';
import { Head, Link, useForm } from '@inertiajs/vue3';

defineProps({
    canResetPassword: {
        type: Boolean,
    },
    status: {
        type: String,
    },
});
</script>

<template>
    <GuestLayout>
        <Head title="Log in" />

        <h3 class="text-xl font-bold text-slate-700 mb-3">Sign in with WEALTH at work</h3>
        <a class="p-3 block w-full bg-indigo-600 hover:bg-indigo-500 rounded-md text-center text-slate-100 transition-all duration-300 ease-in-out" href="/sso">
            Sign in
        </a>
    </GuestLayout>
</template>
